import { MAX_INPUT_LENGTH } from "@finway-group/shared/lib/utils/validators"
import { Col, Form, Input, Row, Switch } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { useExpenseFormContext } from "Components/modals/expenseCreateForm.context"
import { isExpenseBillableAccessible } from "Shared/utils/expense.utils"

import { ExpenseRules } from "../rules"
import TotalAmountForm from "./commonInputFields/totalAmount.form"
import { VendorSelectField } from "./commonInputFields/VendorSelectField"

const BILLABLE_COL_SPAN = 5

export const OneTimeExpenseFields = () => {
    const [expenseFormContext] = useExpenseFormContext()
    const { expense, updateExpense, expenseForm, type, isNew, isLinked, setIsLinked, prefilledVendorData, setPrefilledVendorData } = expenseFormContext

    const { description } = ExpenseRules({ expense })
    const { t } = useTranslation()
    const showBillable = isExpenseBillableAccessible(expense)

    return (
        <>
            <Row gutter={[16, 16]} align="top" className="mt-10">
                <Col span={24 - (showBillable ? BILLABLE_COL_SPAN : 0)} sm="24" md="24">
                    <Form.Item name="description" label={t("input:request.description")} key="description" rules={description}>
                        <Input.TextArea
                            data-testid="descriptionExpenseField"
                            className="leading-normal pt-4"
                            autoSize
                            rows={1}
                            maxLength={MAX_INPUT_LENGTH}
                            name="description"
                            placeholder={t("placeholder:request.description")}
                            onChange={(e) => updateExpense({ description: e.target.value })}
                        />
                    </Form.Item>
                </Col>
                {showBillable && (
                    <Col span={BILLABLE_COL_SPAN}>
                        <Form.Item label={t("input:request.billable")} name="billable" valuePropName="checked" className="content-end">
                            <Switch onChange={(checked) => updateExpense({ billable: checked })} />
                        </Form.Item>
                    </Col>
                )}
            </Row>
            <VendorSelectField
                expense={expense}
                updateExpense={updateExpense}
                expenseForm={expenseForm}
                prefilledVendorData={prefilledVendorData}
                setPrefilledVendorData={setPrefilledVendorData}
            />
            <TotalAmountForm expense={expense} updateExpense={updateExpense} isLinked={isLinked} setIsLinked={setIsLinked} type={type} isNew={isNew} expenseForm={expenseForm} />
        </>
    )
}
